import { render } from "./WebViewer.vue?vue&type=template&id=28d50d99&scoped=true"
import script from "./WebViewer.vue?vue&type=script&lang=js"
export * from "./WebViewer.vue?vue&type=script&lang=js"

import "./WebViewer.vue?vue&type=style&index=0&id=28d50d99&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28d50d99"]])

export default __exports__